import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormFeedback, Input, Label, Offcanvas, OffcanvasBody, OffcanvasHeader, Row } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import Flatpickr from "react-flatpickr";
import { getFinalDestinationList } from '../../../../helpers/residue/backend_helper';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import 'dayjs/locale/es-mx';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import OSelect from '../../../../Components/OElements/OSelect';
import useEstablishmentAssignationUser from '../../../../Components/Hooks/useEstablishmentAssignationUser';
import { getActivityStatusList, getActivityTypeList } from '../../../../helpers/activity/backend_helper';

const OffcanvasContainerActivity = ({ isOpen, toggle, filters, onSubmit }) => {
    const {
        establishments,
        establishmentsListSelect
    } = useEstablishmentAssignationUser();
    const [selectedDate, setSelectedDate] = useState(filters.dateRange);
    const [selectedActivityStatus, setSelectedActivityStatus] = useState(null);
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        
    };

    const handleClearFilters = () => {
        onSubmit({});
        validation.resetForm();
    };

    const validation = useFormik({
        // enableReinitialize: use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            activity_status_id: '',
            activity_type_id: '',
            productive_cycle_code: ''
        },
        validationSchema: Yup.object({
            activity_status_id: Yup.string(),
            activity_type_id: Yup.string(),
            productive_cycle_code: Yup.string()
        }),
        onSubmit: async (values) => {
            const filteredFilters = {};
            if (values.activity_status_id) filteredFilters.activity_status_id = values.activity_status_id;
            if (values.activity_type_id) filteredFilters.activity_type_id = values.activity_type_id;
            if (values.productive_cycle_code) filteredFilters.productive_cycle_code = values.productive_cycle_code;
            onSubmit(filteredFilters);
            toggle();
        }
    });

    return (
        <Offcanvas
            isOpen={isOpen}
            direction="end"
            toggle={toggle}
            className="border-bottom"
        >
            <OffcanvasHeader toggle={toggle}>
                Filtros
            </OffcanvasHeader>
            <OffcanvasBody className="p-3 overflow-hidden">
                <SimpleBar style={{ height: "100vh" }}>
                    <Form
                        className=''
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                    >
                        <Row className='g-3'>
                            <Col lg={12}>
                                <OSelect
                                    key={`activity_status_id${filters?.activity_status_id}` || ''}
                                    label='Estado'
                                    id='activity_status_id'
                                    name='activity_status_id'
                                    value={
                                        filters?.activity_status_id || ''
                                    }
                                    handleLabelOptions={(item) => `${item.name}`}
                                    onSelect={setSelectedActivityStatus}
                                    requestApi={() => getActivityStatusList({})}
                                    validation={validation}
                                />
                            </Col>
                            <Col lg={12}>
                                <OSelect
                                    key={`activity_type_id${filters?.activity_type_id}` || ''}
                                    label='Tipo'
                                    id='activity_type_id'
                                    name='activity_type_id'
                                    value={filters?.activity_type_id || ''}
                                    onSelect={setSelectedActivityType}
                                    requestApi={() => getActivityTypeList({})}
                                    validation={validation}
                                />
                            </Col>
                            <Col lg={12}>
								<Label for='productive_cycle_code' className='form-label'>
									Código Ciclo Productivo
								</Label>
								<Input
									name='productive_cycle_code'
									id='productive_cycle_code'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.productive_cycle_code || ''}
									invalid={
										validation.touched.productive_cycle_code &&
                                        validation.errors.productive_cycle_code
											? true
											: false
									}
								/>
								{
									validation.touched.productive_cycle_code &&
										validation.errors.productive_cycle_code ? (
										<FormFeedback type='invalid'>
											{validation.errors.productive_cycle_code}
										</FormFeedback>
									) : null
								}
							</Col>
                        </Row>
                        
                        <Row>
                            <Col>
                                <div className="hstack gap-2 mt-4">
                                    <button type='submit' className='btn btn-label btn-primary'><i className="ri-filter-fill label-icon"></i> Filtrar </button>
                                    <button type='button' className='btn btn-label btn-primary' onClick={handleClearFilters}><i className="ri-filter-off-fill label-icon"></i> Limpiar</button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </SimpleBar>
            </OffcanvasBody>
        </Offcanvas >
    );
};

export default OffcanvasContainerActivity;
